import { render, staticRenderFns } from "./FlatPattern.vue?vue&type=template&id=7733afd8"
import script from "./FlatPattern.vue?vue&type=script&lang=js"
export * from "./FlatPattern.vue?vue&type=script&lang=js"
import style0 from "./FlatPattern.vue?vue&type=style&index=0&id=7733afd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports